import React from "react";

function DashboardAdmin() {
  return (
    <div className="container mt-5">
      <h2>2Party Dashboard</h2>
      <p>Welcome,2Party</p>
    </div>
  );
}

export default DashboardAdmin;